import { gql } from '@apollo/client';

export const DELETE_USER_PROFESSION = gql`
  mutation DELETE_USER_PROFESSION($professionName: String!) {
    deleteUserProfession(professionName: $professionName) {
      id
      professions {
        name
        id
      }
    }
  }
`;
